import { PayloadAction } from 'app/shared/model/action.model';
import { SupplierPart } from 'app/profile/models/masterdata.model';
import { Region } from 'app/profile/models/supplier.model';
import { FormTemplate } from 'app/profile/models/onboarding.model';
import { createAction, props } from '@ngrx/store';


// Get Address Supplier contact types
export const GET_MD_SUPPLIER_ADDRESS_CONTACT_TYPES = 'GET_MD_SUPPLIER_ADDRESS_CONTACT_TYPES';
export const GET_MD_SUPPLIER_ADDRESS_CONTACT_TYPES_SUCCESS = 'GET_MD_SUPPLIER_ADDRESS_CONTACT_TYPES_SUCCESS';

export class GetSupplierAddressContactTypes implements PayloadAction {
  readonly type = GET_MD_SUPPLIER_ADDRESS_CONTACT_TYPES;
  constructor(public payload?) { }
}
export class GetSupplierAddressContactTypesSuccess implements PayloadAction {
  readonly type = GET_MD_SUPPLIER_ADDRESS_CONTACT_TYPES_SUCCESS;
  constructor(public payload) { }
}

// Get Country List
export const GET_COUNTRY_LIST = 'GET_COUNTRY_LIST';
export const GET_COUNTRY_LIST_SUCCESS = 'GET_COUNTRY_LIST_SUCCESS';
export class GetCountryList implements PayloadAction {
  readonly type = GET_COUNTRY_LIST;
  constructor(public payload?) { }
}
export class GetCountryListSuccess implements PayloadAction {
  readonly type = GET_COUNTRY_LIST_SUCCESS;
  constructor(public payload) { }
}

// Get Language List
export const GET_LANGUAGE_LIST = 'GET_LANGUAGE_LIST';
export const GET_LANGUAGE_LIST_SUCCESS = 'GET_LANGUAGE_LIST_SUCCESS';
export class GetLanguageList implements PayloadAction {
  readonly type = GET_LANGUAGE_LIST;
  constructor(public payload?) { }
}
export class GetLanguageListSuccess implements PayloadAction {
  readonly type = GET_LANGUAGE_LIST_SUCCESS;
  constructor(public payload) { }
}

// Get Region List
export const GET_REGION_LIST = 'GET_REGION_LIST';
export const GET_REGION_LIST_SUCCESS = 'GET_REGION_LIST_SUCCESS';
export class GetRegionList implements PayloadAction {
  readonly type = GET_REGION_LIST;
  constructor(public payload: string) { }
}
export class GetRegionListSuccess implements PayloadAction {
  readonly type = GET_REGION_LIST_SUCCESS;
  constructor(public payload: Region[]) { }
}

// Get Contact Role List
export const GET_CONTACT_ROLE_LIST = 'GET_CONTACT_ROLE_LIST';
export const GET_CONTACT_ROLE_LIST_SUCCESS = 'GET_CONTACT_ROLE_LIST_SUCCESS';
export class GetContactRoleList implements PayloadAction {
  readonly type = GET_CONTACT_ROLE_LIST;
  constructor(public payload?) { }
}
export class GetContactRoleListSuccess implements PayloadAction {
  readonly type = GET_CONTACT_ROLE_LIST_SUCCESS;
  constructor(public payload) { }
}

// Get Supplier Parts
export const GET_PART_LIST = 'GET_PART_LIST';
export const GET_PART_LIST_SUCCESS = 'GET_PART_LIST_SUCCESS';
export class GetPartList implements PayloadAction {
  readonly type = GET_PART_LIST;
  constructor(public payload: string) { }
}
export class GetPartListSuccess implements PayloadAction {
  readonly type = GET_PART_LIST_SUCCESS;
  constructor(public payload: SupplierPart[]) { }
}

// Get Address Supplier contact types
export const GET_TOOL_CATEGORIES = 'GET_TOOL_CATEGORIES';
export const GET_TOOL_CATEGORIES_SUCCESS = 'GET_TOOL_CATEGORIES_SUCCESS';

export class GetToolCategories implements PayloadAction {
  readonly type = GET_TOOL_CATEGORIES;
  constructor(public payload?) { }
}
export class GetToolCategoriesSuccess implements PayloadAction {
  readonly type = GET_TOOL_CATEGORIES_SUCCESS;
  constructor(public payload) { }
}

// Get Address Supplier contact types
export const GET_TOOL_SUB_CATEGORIES = 'GET_TOOL_SUB_CATEGORIES';
export const GET_TOOL_SUB_CATEGORIES_SUCCESS = 'GET_TOOL_SUB_CATEGORIES_SUCCESS';

export class GetToolSubCategories implements PayloadAction {
  readonly type = GET_TOOL_SUB_CATEGORIES;
  constructor(public payload, public forceReload: boolean = false) { }
}
export class GetToolSubCategoriesSuccess implements PayloadAction {
  readonly type = GET_TOOL_SUB_CATEGORIES_SUCCESS;
  constructor(public payload, public supplierCode: string) { }
}

// Get Currency List
export const GET_CURRENCY = 'GET_CURRENCY';
export const GET_CURRENCY_SUCCESS = 'GET_CURRENCY_SUCCESS';
export class GetCurrency implements PayloadAction {
  readonly type = GET_CURRENCY;
  constructor(public payload?) { }
}
export class GetCurrencySuccess implements PayloadAction {
  readonly type = GET_CURRENCY_SUCCESS;
  constructor(public payload) { }
}

// Get Document type List
export const GET_DOCUMENTTYPE = 'GET_DOCUMENTTYPE';
export const GET_DOCUMENTTYPE_SUCCESS = 'GET_DOCUMENTTYPE_SUCCESS';
export class GetDocumentType implements PayloadAction {
  readonly type = GET_DOCUMENTTYPE;
  constructor(public payload?) { }
}
export class GetDocumentTypeSuccess implements PayloadAction {
  readonly type = GET_DOCUMENTTYPE_SUCCESS;
  constructor(public payload) { }
}

export const GET_DIVERSITY_TYPES = 'GET_DIVERSITY_TYPES';
export const GET_DIVERSITY_TYPES_SUCCESS = 'GET_DIVERSITY_TYPES_SUCCESS';
export class GetDiversityTypes implements PayloadAction {
  readonly type = GET_DIVERSITY_TYPES;
  constructor() { }
}
export class GetDiversityTypesSuccess implements PayloadAction {
  readonly type = GET_DIVERSITY_TYPES_SUCCESS;
  constructor(public payload) { }
}


export const GET_AGENCY_TYPES = 'GET_AGENCY_TYPES';
export const GET_AGENCY_TYPES_SUCCESS = 'GET_AGENCY_TYPES_SUCCESS';
export class GetAgencyTypes implements PayloadAction {
  readonly type = GET_AGENCY_TYPES;
  constructor(public payload?) { }
}
export class GetAgencyTypesSuccess implements PayloadAction {
  readonly type = GET_AGENCY_TYPES_SUCCESS;
  constructor(public payload) { }
}


export const GET_FORM_TEMPLATES = 'GET_FORM_TEMPLATES';
export const GET_FORM_TEMPLATES_SUCCESS = 'GET_FORM_TEMPLATES_SUCCESS';
export class GetFormTemplate implements PayloadAction {
  readonly type = GET_FORM_TEMPLATES;
  constructor(public version:number, public payload: string) { }
}
export class GetFormTemplateSuccess implements PayloadAction {
  readonly type = GET_FORM_TEMPLATES_SUCCESS;
  constructor(public payload: FormTemplate) { }
}

// Get Context Verbiage
export const GET_CONTEXT_VERBIAGE = 'GET_CONTEXT_VERBIAGE';
export const GET_CONTEXT_VERBIAGE_SUCCESS = 'GET_CONTEXT_VERBIAGE_SUCCESS';

export class GetContextVerbiage implements PayloadAction {
  readonly type = GET_CONTEXT_VERBIAGE;
  constructor(public payload?) { }
}
export class GetContextVerbiageSuccess implements PayloadAction {
  readonly type = GET_CONTEXT_VERBIAGE_SUCCESS;
  constructor(public payload) { }
}

export const GET_TAX_1099_BOXES = 'GET_TAX_1099_BOXES';
export const GET_TAX_1099_BOXES_SUCCESS = 'GET_TAX_1099_BOXES_SUCCESS';
export class GetTax1099Boxes implements PayloadAction {
  readonly type = GET_TAX_1099_BOXES;
  constructor(public payload?) { }
}
export class GetTax1099BoxesSuccess implements PayloadAction {
  readonly type = GET_TAX_1099_BOXES_SUCCESS;
  constructor(public payload) { }
}


export type MasterDataActions = GetSupplierAddressContactTypes | GetSupplierAddressContactTypesSuccess
  | GetCountryList | GetCountryListSuccess | GetLanguageList | GetLanguageListSuccess
  | GetContactRoleList | GetContactRoleListSuccess | GetPartList | GetPartListSuccess
  | GetToolCategories | GetToolCategoriesSuccess
  | GetToolSubCategories | GetToolSubCategoriesSuccess
  | GetCurrency | GetCurrencySuccess
  | GetDocumentType | GetDocumentTypeSuccess
  | GetRegionList | GetRegionListSuccess
  | GetDiversityTypes | GetDiversityTypesSuccess
  | GetAgencyTypes | GetAgencyTypesSuccess | GetFormTemplate | GetFormTemplateSuccess
  | GetContextVerbiage | GetContextVerbiageSuccess
  | GetTax1099Boxes | GetTax1099BoxesSuccess;
